/**
 * Категории событий
 *
 * @name constants.EVENTS
 * @type {Record<string, string>}
 * @deprecated
 */
export const CATEGORIES = {
    applicationForm: 'application_form',
    applicationButton: 'application_button',
    applicationManagement: 'application_management',
    auth: 'Auth',
    abnTests: 'abn tests',
    bundles: 'bundles',
    banner: 'banner',
    bannerServices: 'banner_services',
    bannerOverHeader: 'banner_over_header',
    bonus: 'bonus',
    changePassword: 'changePassword',
    connectRequest: 'connect request',
    crash: 'CRASH',
    cbFormNew: 'callback form new',
    delivery: 'delivery',
    dealerWidget: 'dealer_widget',
    deviceManagement: 'device_management',
    equipment: 'equipment',
    fullBuy: 'fullbuy',
    fullBuyEquip: 'full_buy_equip',
    header: 'Header',
    loyaltyProgramLanding: 'loyalty_program_landing',
    landing: 'landing',
    mainMenuClick: 'Main menu click',
    multibundleWidget: 'multibundle_widget',
    multibundle: 'multibundle',
    miniMenuClick: 'Mini menu click',
    miniMenuHover: 'Mini menu hover',
    newPayment: 'new_payment',
    orderManagement: 'order_management',
    paidServices: 'paid_services',
    phoneStatistic: 'phone_statistics',
    purchaseEquipment: 'purchase_equipment',
    spas: 'spas',
    tariffCards: 'tariff_cards',
    tariffLines: 'tariff_lines',
    tariffChange: 'tariff change',
    vas: 'VAS',
    lk: 'lk',
    seasonTickets: 'season tickets',
    profileMenu: 'profile_menu',
    agreementMenu: 'agreement_details_menu',
    lkMenu: 'lk_main_navigation',
    onlineBuy: 'online_buy',
    equipmentPayment: 'equipment_payment',
    constructor: 'constructor',
    diagnosticsLk: 'diagnostics_lk',
    support: 'support',
};

/**
 * Тип действия событий
 *
 * @name constants.ACTIONS
 * @type {Record<string, string>}
 * @deprecated
 */
export const ACTIONS = {
    addRemoveFilter: 'add/remove filter',

    cancelServiceRequest: 'cancel_service_request',
    click: 'click',
    clickOnBtn: 'click_on_btn',
    clickChooseTariff: 'click_choose_tariff',
    clickViewAll: 'click view all',
    clickOrder: 'click order',
    clickChooseBtn: 'click choose btn',
    clickOnCalltouch: 'click_on_calltouch',
    clickBanner: 'click banner',
    clickChooseCb: 'click choose сallback',
    clickTicketOpen: 'click check payment',
    clickContinueOnline: 'click_continue_online',
    clickConnectForRouble: 'click_connect_for_ruble',
    clickConnectByPhone: 'open_connect_by_phone',
    clickConnectForRoublePopup: 'click_connect_for_ruble_popup',
    choiceRecommendedTariff: 'choice_recommended_tariff',
    chooseRouter: 'choose_router',
    clickAgreeBtn: 'click agree btn',
    clickConsultation: 'click_get_consultation',
    clickDisagreeBtn: 'click disagree btn',
    clickFindPrice: 'click_find_price',
    clickProblem: 'click_problem_solution',
    clickedToOrder: 'clicked_to_order',
    clickConnectChoosedSpeed: 'click_connect_choosed_speed',

    error: 'error',
    errorService: 'error_service',
    errorEquip: 'error_equipment',
    errorVas: 'error_vas',

    finished: 'finished',

    move: 'move',
    moveSpeedSlider: 'move_speed_slider',

    navigationClick: 'navigation_click',

    openLazyPopup: 'open_lazy_application',
    openCallbackForm: 'open_callback_form',
    orderVas: 'order_vas',
    orderService: 'order_service',
    orderEquip: 'order_equipment',

    popup: 'popup',

    routers: 'routers',

    checkboxTvChannelsOn: 'checkbox_tv_channels_on',
    checkboxTvChannelsOff: 'checkbox_tv_channels_off',

    serviceRequest: 'service_request',
    started: 'started',
    startedEquip: 'started_equipment',
    startedService: 'started_service',
    startedVas: 'started_vas',
    success: 'success',
    serviceRequestEdit: 'edit_service_request',
    showRecommendedTariff: 'show_recommended_tariff',

    transitionToForm: 'transition_to_form',

    view: 'view',
};

/**
 * Типы событий
 *
 * @name constants.EVENTS
 * @type {Record<string, string>}
 */
export const EVENTS: Record<string, string> = {
    UAevent: 'UAevent',
};
